$(function () {

  // ソトマチ一覧 検索条件変更
  $('#js-sotomachi-search-datetime').on('change', (e) => {
    $(e.target).closest("form").submit();
  });

});
